import store from '@/store/index'
import * as security from '@/common/security'
import {
  AUTH_GET_TOKEN
} from '@/store/auth/auth.types'
import ApiService from '@/common/api.service'

import {
  GET_REQUEST,
  REQUEST_POOLS
} from './websentinel.types'

const state = {
}

const getters = {
}

const actions = {
  [GET_REQUEST] (context, { resource, params }) {
    const websentinel_url = security.user().websentinel_url
    const url = `${websentinel_url}/api/v1/`

    // Note: We pass the token through as well otherwise
    // the ApiService will override the token with the
    // token received from WebSentinel, which we don't want.
    return ApiService
      .get(resource, params, url, store.getters[AUTH_GET_TOKEN])
      .then((response) => {
        return response
      })
  },

  [REQUEST_POOLS] (context, params) {
    return context.dispatch(GET_REQUEST, {
      resource: 'events/pools',
      params: params
    })
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/websentinel/websentinel.js